import { useMemo, JSX } from "react";
import { ProgressBar } from "../..";
import { CellContext } from "@tanstack/react-table";
import { EditAbleCell } from "./styledTableCell";
import { IdentifiableRow } from "../reactiveTableRenderer";

import { isObject } from "lodash";

export const ProgressTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn}: CellContext<T, JSX.Element | string | undefined> & EditAbleCell<T>) => {
  const initialValue = useMemo(() => getValue(), [getValue]);

  if (isObject(initialValue)) {
    return (
      <div style={{opacity: canEdit ? "0.5" : "1"}}>
        {initialValue}
      </div>
    )
  }

  return (
    <div style={{opacity: canEdit ? "0.5" : "1"}}>
      <ProgressBar extension={{hasExtension: true}} />
    </div>
  )
}